import ScanIcon from '@/icons/scan-icon';

export default function ScanGiftCard(props: {
  onNavigate: (path: string) => void;
}) {
  return (
    <div
      className={
        'click-effect mx-auto flex min-h-[400px] w-full rounded-lg border border-silver'
      }
    >
      <div
        className="flex w-full flex-col items-center justify-center"
        onClick={() => props.onNavigate('/gift-card/verify')}
      >
        <div className="flex items-center justify-center h-32">
          <ScanIcon style={{ width: 88, height: 88 }} />
        </div>
        <h5 className="text-2xl font-bold">Sell/Check Gift Card</h5>
      </div>
    </div>
  );
}
